module.exports = __webpack_public_path__ + "static/media/facebookIcon.de6f25f7.svg";